import React from 'react';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';

const PublicIndicatorDot = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="4"
    height="4"
    viewBox="0 0 4 4"
    fill="none"
    className="animate-pulse-strong"
  >
    <circle cx="2" cy="2" r="2" fill="#46960D" />
  </svg>
);

export const PublicIndicatorPill: React.FC<{
  collapseToIndicatorBelow1240?: boolean;
}> = ({ collapseToIndicatorBelow1240 = false }) => {
  const language = useLanguage();

  if (collapseToIndicatorBelow1240) {
    return (
      <>
        <div className="min-[1024px]:hidden">
          <PublicIndicatorDot />
        </div>
        <Spacing
          direction="horizontal"
          size="sm"
          className="hidden rounded border border-[#D0E8CA] bg-[#F2FAF0] items-center py-1 px-2 min-[1024px]:flex"
        >
          <PublicIndicatorDot />
          <S2Typography
            translatedContent={language.public()}
            variant={'small-label-bold'}
            textColorVariant={'green-600'}
          />
        </Spacing>
      </>
    );
  }

  return (
    <Spacing
      direction="horizontal"
      size="sm"
      className="rounded border border-[#D0E8CA] bg-[#F2FAF0] items-center py-1 px-2"
    >
      <PublicIndicatorDot />
      <S2Typography
        translatedContent={language.public()}
        variant={'small-label-bold'}
        textColorVariant={'green-600'}
      />
    </Spacing>
  );
};
